export function scrollToElement (target, customOffsetTop, customOffsetBottom, scrollFinishCallback) {
    if (!target) return;

    initScroll().then(scrollFinishCallback);


    function initScroll() {

        return new Promise((resolve) => {
            target.style.scrollMargin = `
            ${((customOffsetTop || customOffsetTop === 0) ? customOffsetTop : 16) + getHeaderHeight()}px
            ${((customOffsetBottom || customOffsetBottom === 0) ? customOffsetBottom : 16)}px`;

            target.scrollIntoView({
                behavior: 'smooth',
            });


            const onScroll = () => {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(() => {
                    window.removeEventListener("scroll", onScroll);
                    resolve();
                }, 50);
            };

            let scrollTimeout;
            window.addEventListener("scroll", onScroll);
        });
    }
}

export function getHeaderHeight() {
    const header = document.querySelector(".shop-header");
    if (!header) return 0;

    let headerHeight = header.clientHeight;
    if (headerHeight === 0) return 0;

    return (headerHeight + getScrollOffset(header));
}

function getScrollOffset(header) {
    let offset = 0;

    const cs = getComputedStyle(document.documentElement);
    
    let headerScrollTransform = parseFloat(cs.getPropertyValue('--headerScrollTransform'));
    if (headerScrollTransform) offset += headerScrollTransform;

    let headerHeightChange = parseFloat(cs.getPropertyValue('--headerHeightChange'));
    if (!header.classList.contains("stuck") && headerHeightChange) offset -= headerHeightChange;

    return offset;
}